import {resolveBackground} from '#core/utils/color-utils.js';

import {BadRouteHeadMetaFactory} from '#core/application/seo/head-meta-factory.js';

import {generatePrimaryButton} from '#core/application/modules/tiles/button/index.js';

export function badRoutePageFactory(PALETTE) {
    return {
        BadRoutePageView: {
            documentHeadMetaFactory: BadRouteHeadMetaFactory,
            container: {
                style: {
                    ...resolveBackground(PALETTE.BAD_ROUTE_PAGE_BG),
                    top: 'initial',
                    bottom: 'initial',
                },
            },
            errorCode: {
                style: {
                    ...PALETTE.BAD_ROUTE_PAGE_TITLE_TEXT,
                },
            },
            information: {
                style: {
                    _mobile_fontSize: '16px',
                    ...PALETTE.BAD_ROUTE_PAGE_INFO_TEXT,
                },
            },
            logo: {
                src: 'bad-route/logo.svg',
            },
            homeButton: generatePrimaryButton(PALETTE.BAD_ROUTE_PAGE_HOME_BUTTON),
        },
    };
}
